module.exports = __webpack_public_path__ + "static/img/009.822f41af.png";